export default __webpack_public_path__ + "static/media/MaleUser.23221412.svg";